import Home from "@/views/Home.vue";
import Landing from "@/views/Landing.vue";
import Login from "@/views/Login.vue";
import OAuthReply from "@/views/OAuthReply.vue";
import ContentBlockList from "@/views/content-blocks/List.vue";
import CreateContentBlock from "@/views/content-blocks/Create.vue";
import Templates from "@/views/templates/Templates.vue";
import SectionList from "@/views/sections/List.vue";
import CreateSection from "@/views/sections/Create.vue";
import EditSection from "@/views/sections/Edit.vue";
import TagBrowser from "@/views/tags/TagBrowser.vue";
import BusinessRulesList from "@/views/business-rules/List.vue";
import CreateBusinessRule from "@/views/business-rules/Create.vue";
import EditBusinessRule from "@/views/business-rules/Edit.vue";
import DocumentBrowser from "@/views/document/Browser.vue";
import FinalizeDocument from "@/views/document/Finalize.vue";
import RelatedContent from "@/views/related-content/RelatedContent.vue";
import Advanced from "@/views/advanced/Advanced.vue";
import Settings from "@/views/Settings.vue";
import Reset from "@/views/Reset.vue";
import IE from "@/views/IE.vue";
import Help from "@/views/help/Help.vue";
import Log from "@/views/diagnostics/Log.vue";
import Logout from "@/views/Logout.vue";

export default [
    { path: "/", component: Home },
    { path: "/landing", component: Landing },
    { path: "/reset", component: Reset },
    { path: "/settings", component: Settings },
    { path: "/login", component: Login },
    { path: "/oAuthReply", component: OAuthReply },    
    { path: "/contentblocks/create", name: "CreateContentBlock", component: CreateContentBlock },
    { path: "/contentblocks/:include?", name: "ContentBlocks", component: ContentBlockList, props: true },
    { path: "/templates", component: Templates },
    { path: "/sections", component: SectionList },
    { path: "/sections/create", component: CreateSection },
    { path: "/sections/edit/:id", component: EditSection, props: true },
    { path: "/tags", component: TagBrowser },
    { path: "/businessrules", component: BusinessRulesList },
    { path: "/businessrules/create", component: CreateBusinessRule },
    { path: "/businessrules/edit/:id", component: EditBusinessRule, props: true },
    { path: "/document-browser", component: DocumentBrowser },
    { path: "/finalize-document", component: FinalizeDocument },
    { path: "/related-content", component: RelatedContent },
    { path: "/advanced", component: Advanced },
    { path: "/ie-support", name: "IeSupport", component: IE },
    { path: "/help/:page", name: "Help", component: Help, props: true },
    { path: "/diagnostics/log", name: "Log", component: Log },
    { path: "/logout", component: Logout }
];